import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import App from '../App.jsx';
import Mobile from './Mobile';

const DeviceDetector = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { tripId } = useParams();

  useEffect(() => {
    // Function to check if the screen width is mobile
    const checkIfMobile = () => {
      const mobileBreakpoint = 768; // Set your mobile breakpoint here
      const currentWidth = window.innerWidth;
      setIsMobile(currentWidth <= mobileBreakpoint);
      console.log('Window width:', currentWidth, 'isMobile:', currentWidth <= mobileBreakpoint);
    };

    // Check on initial load
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Clean up event listener
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Render the appropriate component based on device type and pass the tripId
  return isMobile ? <Mobile tripId={tripId} /> : <App tripId={tripId} />;
};

export default DeviceDetector;
